import React, { useMemo } from 'react'
import { Flex, SkeletonLoader } from '@grammarly/design-system'

interface AIDetectorLoadingProps {
  numLoadingLines: number
  labelOffset?: number
}

export const AIDetectorLoading: React.FC<AIDetectorLoadingProps> = ({ numLoadingLines, labelOffset }) => {
  const numLinesArray = useMemo(
    () => Array.from({ length: numLoadingLines || 10 }, () => Math.ceil(95 + 5 * Math.random())),
    [numLoadingLines]
  )

  return (
    <Flex gap={5} justify="space-between">
      <SkeletonLoader
        accessibilityLabel="Checking text for AI"
        label="Checking text for AI"
        width="100%"
        labelOffset={labelOffset}
      >
        <Flex direction="column" gap={1} width="100%">
          {numLinesArray.map((percent, index) => (
            <SkeletonLoader.Text key={`skeleton-text-${index}`} variant="text-medium" width={`${percent}%`} />
          ))}
        </Flex>
      </SkeletonLoader>
    </Flex>
  )
}
